import React from "react";
import { CatListDropdown } from "@/components/FileInput";
import BarChart3 from "@/components/BarChart3";

const SecondAsset = ({ assetArray, secondAsset, secondAssetOptions, handleSecondAsset }) => {
  return (
    <div className="grid grid-cols-12 gap-2 sm:gap-5">
      <div className="col-span-12 sm:col-span-7">
        <div className="w-full bg-white rounded-lg shadow-xl shadow-slate-300 p-5">
          <BarChart3
            min={assetArray.min}
            max={assetArray.max}
            average={assetArray.average}
          />
        </div>
      </div>
      <div className="col-span-12 sm:col-span-5">
        <div className="text-sm">
          <CatListDropdown
            id={"SecondAssetDropdown"}
            className={
              "max-w-full m-0 mb-2 border border-gray-300 rounded-md px-2 h-8 py-1 text-black text-sm"
            }
            value={secondAsset}
            options={secondAssetOptions}
            onChange={handleSecondAsset}
            data-testid="main-second-asset-select" />
        </div>
        <div className="mt-1">
          <span className={ "text-xs bg-white whitespace-nowrap text-gray-700 font-semibold py-2 px-2 border-gray-400 rounded-lg shadow-lg shadow-slate-300"}>
            {`AM: ${parseFloat(assetArray.am).toFixed(1)}%`}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SecondAsset;
